export const status = {
  error: '#f61067',
  warning: '#ff6d00',
  info: '#529acb',
  success: '#4add90',
} as const;
